import { Examples } from '@/types';

export const ExampleDirtyChangesRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.ExampleDirtyChanges,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "ExampleDirtyChanges" */
                '@/views/examples/ExampleDirtyChanges.vue'
              )
          }
        }
      ]
    : [];
